import { StationTechnicalModeEnum } from './StationTechnicalModeEnum';
import { UpdateLicenseKeyStrategyEnum } from './UpdateLicenseKeyStrategy';

export const calculateUpdateLicenseKeyStrategyByTechnicalMode = (mode: StationTechnicalModeEnum): UpdateLicenseKeyStrategyEnum => {
    return mode === StationTechnicalModeEnum.ON ? UpdateLicenseKeyStrategyEnum.SOCKET : UpdateLicenseKeyStrategyEnum.HTTP;
};
